import React from 'react';

/**
 * EmptyState — tutarlı "henüz kayıt yok" kartı.
 * Büyük emoji/ikon + başlık + açıklama + opsiyonel CTA butonu.
 *
 * Usage:
 *   <EmptyState
 *     icon="🎫"
 *     title={t('noPromoCodesYet')}
 *     description={t('createFirstPromoCode')}
 *     actionLabel={t('newCodeBtn')}
 *     onAction={() => setShowModal(true)}
 *   />
 */
export default function EmptyState({
  icon = '📭',
  title,
  description,
  actionLabel,
  onAction,
  secondaryLabel,
  onSecondary,
  className = '',
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center px-4 py-12 ${className}`}
      role="status"
    >
      <div className="text-6xl mb-4 opacity-80" aria-hidden="true">{icon}</div>
      {title && (
        <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-1.5">
          {title}
        </h3>
      )}
      {description && (
        <p className="text-sm text-gray-500 dark:text-gray-400 max-w-sm mb-5">
          {description}
        </p>
      )}
      {(actionLabel || secondaryLabel) && (
        <div className="flex flex-col sm:flex-row gap-2">
          {actionLabel && onAction && (
            <button
              onClick={onAction}
              className="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-semibold rounded-xl text-sm transition-colors active:scale-[0.98]"
            >
              {actionLabel}
            </button>
          )}
          {secondaryLabel && onSecondary && (
            <button
              onClick={onSecondary}
              className="px-5 py-2.5 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 font-semibold rounded-xl text-sm hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors active:scale-[0.98]"
            >
              {secondaryLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
